import { Pressable } from 'react-native'
import { Label } from '~/components/typography/Content.tsx'
import { Checkbox } from '~/components/ui/checkbox'
import { cn } from '~/lib/utils.ts'

type ContactConsentConfirmationProps = {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  label: string
  className?: string
  testID?: string
}

export function ContactConsentConfirmation({
  checked,
  onCheckedChange,
  label,
  className,
  testID,
}: ContactConsentConfirmationProps) {
  return (
    <Pressable
      testID={testID}
      className={cn('flex flex-1 flex-row items-center gap-3', className)}
      onPress={() => {
        onCheckedChange(!checked)
      }}>
      <Checkbox
        checked={checked}
        onCheckedChange={(nextChecked: boolean) => {
          onCheckedChange(nextChecked ?? false)
        }}
        variant="outline"
        className="size-7 flex-initial"
      />
      <Label className="flex-1 font-normal text-base text-foreground">{label}</Label>
    </Pressable>
  )
}
